import {CallCause, CallCauseUtil} from './call-cause';

export class RedirectEntry {
  phonenumber: string;
  callCause: number;
  name: string;
  cssClass: string;
  icon: string;

  private constructor(redirectNumberString: string) {
    const redirectNumberArray = redirectNumberString.split(':');
    this.phonenumber = redirectNumberArray[0];
    this.callCause = redirectNumberArray[1] ? +redirectNumberArray[1] : CallCause.UnknownCause;

    this.setCssClass();
  }

  public static parse(history: string): RedirectEntry[] {
    if (history && history.length) {
      return history.split(',')
        .filter(entry => {
          const name = entry.split(':')[0];
          return name.length && !name.startsWith('null');
        })
        .map(entry => new RedirectEntry(entry));
    }
    return [];
  }

  getCallCauseString(): string {
    return CallCauseUtil.getCallCauseString(this.callCause);
  }

  setCssClass() {
    if (CallCauseUtil.isCallAnswered(this.callCause)) {
      this.cssClass = 'color-green';
      this.icon = 'phone_in_talk';
    } else if (CallCauseUtil.isAAbandon(this.callCause)) {
      this.cssClass = 'color-red';
      this.icon = 'call_end';
    } else if (CallCauseUtil.isCallMissed(this.callCause)) {
      this.cssClass = 'color-red';
      this.icon = 'phone_missed';
    } else {
      this.cssClass = 'color-yellow';
      this.icon = 'phone_forwarded';
    }
  }
}
